<div class="label-container" *ngIf="label">
    <label [for]="name">{{ getLabel() }}</label>
</div>

<div class="border"
     #border
     (focusin)="onFocus()"
     (focusout)="onBlur()"
     tabindex="0">


    <div class="options-container" *ngIf="valueAsOptions?.length">

        <div class="options">
            <div class="option-container" *ngFor="let option of valueAsOptions; let i = index, trackBy: trackByFn" [id]="name+'-option-' + i">
                <div class="option"
                     [class.disabled]="option.isDisabled">
                    <div class="option-label" [title]="option.label">{{ option.label }}</div>
                    <button type="button" class="btn btn-icon-only"
                            (click)="onRemoveItemBtnClick(i)"
                            [disabled]="option.isDisabled">
                        <i class="fa" [ngClass]="getFaIconClass(option)"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="placeholder" *ngIf="!valueAsOptions?.length">
        <div [innerHTML]="placeholderHtml" class="placeholder-text"></div>
    </div>

</div>
